import {
  InventoryLevelsResponse,
  LocationResponseDto,
  VariantCreateRequestApiV2Dto,
  VariantRequestDto,
} from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { getVariantMetafields } from '../getCreateProductPayload/helpers';

const getLocationId = (
  newVariant: VariantRequestDto,
  mainLocation?: LocationResponseDto,
) =>
  newVariant.locationId
    ? newVariant.locationId
    : mainLocation
    ? mainLocation.id
    : '';

const getInventoryLevels = (
  newVariant: VariantRequestDto,
  mainLocation?: LocationResponseDto,
): { inventory_levels: InventoryLevelsResponse[] } => {
  const locationId = getLocationId(newVariant, mainLocation);
  return newVariant.inventory_levels && newVariant.inventory_levels.length > 0
    ? {
        inventory_levels: newVariant.inventory_levels.map((level) => ({
          location_id: newVariant.locationId
            ? newVariant.locationId
            : level.location_id
            ? level.location_id
            : '',
          stock:
            newVariant.stock !== undefined
              ? newVariant.stock
              : level.stock
              ? level.stock
              : null,
        })),
      }
    : {
        inventory_levels: [
          { location_id: locationId, stock: newVariant.stock ?? null },
        ],
      };
};

export const getCreateVariantPayload = (
  newVariant: VariantRequestDto,
  language: LanguagesType,
  mainLocation?: LocationResponseDto,
): VariantCreateRequestApiV2Dto => ({
  price: newVariant.price ?? 0,
  attributes: newVariant.values.map((value) => ({
    ...value,
    default: value[language],
  })),
  weight: Number(newVariant.weight) || 0,
  width: Number(newVariant.width) || 0,
  height: Number(newVariant.height) || 0,
  depth: Number(newVariant.depth) || 0,
  visible: newVariant.visible ?? true,
  ...getInventoryLevels(newVariant, mainLocation),
  ...(newVariant.image_id ? { image_id: newVariant.image_id } : {}),
  ...(newVariant.cost !== undefined ? { cost: Number(newVariant.cost) } : {}),
  ...(newVariant.promotional_price !== undefined
    ? { promotional_price: Number(newVariant.promotional_price) }
    : {}),
  ...(newVariant.sku && { sku: newVariant.sku }),
  ...(newVariant.barcode && { barcode: newVariant.barcode }),
  ...(newVariant.mpn && { mpn: newVariant.mpn }),
  ...(newVariant.age_group && { age_group: newVariant.age_group }),
  ...(newVariant.gender && { gender: newVariant.gender }),
  ...(getVariantMetafields(newVariant.metafields) ?? {}),
});
